import { createClient } from '@supabase/supabase-js';

// Main Reports database
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://mzgkjbvtwzruatguchhv.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_UI8G1412_jnV2SrbN8wSfg_fOdjdK-a';

// Logs database (for webhook_logs) - SINGLE INSTANCE to avoid duplicate GoTrueClient
const LOGS_SUPABASE_URL = process.env.REACT_APP_LOGS_SUPABASE_URL || 'https://ecmwjnwrmcsrvrzviraw.supabase.co';
const LOGS_SUPABASE_ANON_KEY = process.env.REACT_APP_LOGS_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVjbXdqbndybWNzcnZyenZpcmF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgzOTc1OTEsImV4cCI6MjA4Mzk3MzU5MX0.toTWBHeC6K5L-JW3t3lbccWfa5KkFjO4fyxfB__SnPM';

// Create clients
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
export const supabaseLogsDb = createClient(LOGS_SUPABASE_URL, LOGS_SUPABASE_ANON_KEY);

// Alias for backward compatibility and clarity
export const logsSupabase = supabaseLogsDb;

